export enum NotificationsSidebarStatus {
	Open,
	Close,
}

export enum NotificationType {
	Volume = 'volume',
}

export enum ChangeLevel {
	Up,
	Down,
}
